// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseAdminFactory instead of class inheritance

import { createBaseAdmin, type IBaseAdmin } from "../BaseAdminFactory";
import type { DocumentType } from "le-coffre-resources/dist/Admin";
import type { QueryPayload } from "../../../types";
import type { IGetDocumentTypesparams, IPutDocumentTypesParams, IPostDocumentTypesParams } from "./DocumentTypes";
import {
	createGetMethod,
	createPostMethod,
	createGetByUidMethod,
	createPutMethod,
} from "./helpers/documentTypesMethodsHelpers";

interface DocumentTypesInstance {
	get(q: IGetDocumentTypesparams): Promise<DocumentType[]>;
	post(body: IPostDocumentTypesParams): Promise<DocumentType>;
	getByUid(uid: string, q?: QueryPayload): Promise<DocumentType>;
	put(uid: string, body: IPutDocumentTypesParams): Promise<DocumentType>;
}

// Module-level singleton instance
let instance: DocumentTypesInstance | null = null;
let baseAdminInstance: IBaseAdmin | null = null;

function createDocumentTypes(): DocumentTypesInstance {
	if (!baseAdminInstance) {
		baseAdminInstance = createBaseAdmin();
	}

	const baseAdmin = baseAdminInstance;
	const baseUrl = baseAdmin.namespaceUrl.concat("/document-types");

	return {
		get: createGetMethod(baseAdmin, baseUrl),
		post: createPostMethod(baseAdmin, baseUrl),
		getByUid: createGetByUidMethod(baseAdmin, baseUrl),
		put: createPutMethod(baseAdmin, baseUrl),
	};
}

export function getDocumentTypesInstance(): DocumentTypesInstance {
	if (!instance) {
		instance = createDocumentTypes();
	}
	return instance;
}
